import { buildProps } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'
import type Trend from './trend.vue'

export const trendProps = buildProps({
  value: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    values: ['up', 'down'],
    default: 'up',
  },
  reverse: {
    type: Boolean,
    default: false,
  },
  prefix: {
    type: String,
    default: '',
  },
  suffix: {
    type: String,
    default: '',
  },
  variant: {
    type: String,
    default: 'default',
    values: ['default', 'filled', 'soft', 'outline'],
  },
  size: {
    type: String,
    default: 'middle',
    values: ['small', 'middle', 'large'],
  },
} as const)

export type TrendProps = ExtractPropTypes<typeof trendProps>

export type TrendInstance = InstanceType<typeof Trend>
